import { Button } from '@mui/material'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import GoogleIcon from '../../assets/icons/google.svg'
import { auth } from '../../firebase'

import { setUserAuth, setUserProfile } from '@/Redux/userSlice'
import { useAuth } from '@/hooks/useAuth'

function GoogleLoginButton({ onClick = null, redirect = null, sx = {}, ...rest }) {
  const { getProfile } = useAuth()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const signInWithGoogle = async () => {
    const GoogleProvider = new GoogleAuthProvider()

    GoogleProvider.setCustomParameters({
      prompt: 'select_account',
    })
    signInWithPopup(auth, GoogleProvider)
      .then(async result => {
        const user = result.user

        console.log('Login with Google successful', result?.user?.email)
        const profile = await getProfile(user.uid)

        dispatch(
          setUserAuth({
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            createdAt: user.metadata.creationTime,
            lastLogin: user.metadata.lastSignInTime,
          }),
        )
        dispatch(setUserProfile(profile))
        if (!profile?.roles) {
          navigate(`/onboarding${redirect && redirect !== '/' ? `?redirect=${encodeURIComponent(redirect)}` : ''}`)
        } else {
          navigate(redirect)
        }
      })
      .catch(error => {
        console.log('Login with Google failed', error)
        alert('You may have a popup blocker enabled. Please disable it and try again to login with Google.')
        throw new Error(error)
      })
  }

  return (
    <Button
      fullWidth
      color="secondary"
      startIcon={
        <img
          alt="google"
          src={GoogleIcon}
          style={{
            width: '30px',
            height: '30px',
          }}
        />
      }
      sx={{
        textTransform: 'none',
        height: 44,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        ...sx,
      }}
      variant="outlined"
      onClick={onClick ? onClick : () => signInWithGoogle()}
      {...rest}
    >
      Sign in with Google
    </Button>
  )
}

export default GoogleLoginButton
